import React, {Component} from 'react';
import { connect } from 'react-redux';
import iconPath from "../../../helpers/iconHelper";
import { Link } from 'react-router-dom';
import {encrypt} from "../../../helpers/CryptoJs"
import FeedFooterCommentDetails from "../../FeedContainer/FeedFooterCommentDetails";
import FeedFooterLike from "../../FeedContainer/FeedFooterLike";
import AddboxRight from "../../FeedContainer/AddboxRight";
import Imagemodal from "../../FeedContainer/FeedImage/Imagemodal";
import { getlanguagelist } from "../../../helpers/changelanguage";
import App from '../../FeedContainer/FeedImage/demo/App';
import $ from "jquery";
import "../album.css";


class ImageList extends Component {
    constructor(props) {
      super(props);
      this.state = {
        albumId            : this.props.albumId,
        albumMedia         : this.props.albumMedia,
        albumReaction      : this.props.albumReaction,
        currentActiveImage : null,
        carousalFeed       : 0
      };
     this.scrollto   = this.scrollto.bind(this);
     this.openModal  = this.openModal.bind(this);
     this.changeView = this.changeView.bind(this);
     this.setImageindex = this.setImageindex.bind(this);
     
    }


    changeView(){
        this.props.changeView('edit',this.state.albumId)
    }
    componentDidMount() {
     
    }
    UNSAFE_componentWillReceiveProps(nextProps,prevProps){
     
    }
    scrollto(){
        $('html, body').animate({
            'scrollTop' : $("#scrollto").position().top
        });
    }
    openModal(index){
        this.setState({
            currentActiveImage : index, 
            carousalFeed       : '499'
        })
    }
    setImageindex (index) {
        console.log(index);
        this.props.toggleLightbox(index)
    }
    render() {
      
    let albumMedia    = this.props.media_details;
   // let albumReaction = this.props.albumReaction;
    let  languagelist = getlanguagelist();
    return (
        
                <ul className="album-dt-ul">
                    { (albumMedia.length > 0) ?
                        albumMedia.map((tile,index) => { 
                            return(
                                <li key={`album_media${index}`} onClick={()=>this.setImageindex(index)}>
                                    <a className="portfolio_box" href={void(0)}>
                                        
                                        {
                                            (tile.media_type == 'IMAGE') ?
                                            <img src={(tile.media_link != '') ? tile.media_link : iconPath['BREAKIMAGE']} 
                                                onError = {(e) => {
                                                    e.target.src = iconPath['BREAKIMAGE']
                                                }} 
                                                
                                            />
                                            : 
                                            <video controls controlsList='nodownload' >
                                                <source src={tile.media_link} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video> 
                                        }
                                    </a>
                                </li>
                            )
                        })
                        : null
                    }
                </ul>
                

                  
    );
  }
}
const mapStateToProps = state => {
  return {
    currentUserDetails : state.login.user,
  }
}
const mapDispatchToProps = dispatch => {
  return {
   
   
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImageList);

